import { Dispatch, SetStateAction } from 'react';
import { IUser, PDFModal, viewUserProfile } from '../common';
import {
  UserTabs,
  ViewUserProfile,
  ViewUserProfileDetails,
  UpdateUserProfileDetails,
} from '.';
import { styled } from '@mui/material';

export const render = ({
  user,
  currentTab,
  edit,
  setCurrentTab,
  setEdit,
  hasActiveRequests
}: {
  user: IUser;
  currentTab: number;
  edit: boolean;
  setCurrentTab: Dispatch<SetStateAction<number>>;
  setEdit: Dispatch<SetStateAction<boolean>>;
  hasActiveRequests: boolean;
}) => (
  <Articl>
    <ViewUserProfile
      user={user}
      edit={edit}
      hasActiveRequests={hasActiveRequests}
      details={() =>
        viewUserProfile(user)(edit) ? (
          <ViewUserProfileDetails user={user} />
        ) : (
          <UpdateUserProfileDetails user={user} setEdit={setEdit} />
        )
      }
      setEdit={setEdit}
    />
    {viewUserProfile(user)(edit) ? (<InstructionsDiv> 
      <PDFModal
        fileUrl={'Create a Request.pdf'}
        fileLabel={'create request instructions'}
        fileDownload="create_req_instructions.pdf"
      />
      {/* <PDFModal
        fileUrl={'Name Change Instructions.pdf'}
        fileLabel={'Name change instructions'}
        fileDownload="name_change_instructions.pdf"
      /> */}
    </InstructionsDiv>) :
      <></>}
    <UserTabs
      user={user}
      currentTab={currentTab}
      setCurrentTab={setCurrentTab}
    />
  </Articl>
);

const Articl = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem !important',
  },
}));

const InstructionsDiv = styled('article')(({ theme }) => ({
  display: 'flex', 
  gap: '16px',
  marginBottom: '5px', 
  marginLeft: '0%',
}));
